// @generated by protoc-gen-connect-es v1.1.3 with parameter "target=ts+js+dts,import_extension=.mjs"
// @generated from file myid/api/myid.proto (package greyhole.myid, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { AddCredentialRequest, BanUserReply, BanUserRequest, BanUsersReply, BanUsersRequest, ChangePasswordRequest, ChangePlayerPasswordReply, ChangePlayerPasswordRequest, CheckCredentialRequest, CheckCredentialsReply, ConfirmCryptoWalletReply, ConfirmCryptoWalletRequest, ConfirmSignInReply, ConfirmSignInRequest, ConfirmSignUpReply, ConfirmSignUpRequest, CreateAccessTokenReply, CreateAccessTokenRequest, CreatePasswordRequest, CreateUserReply, CreateUserRequest, DeleteCryptoWalletCredentialRequest, DeleteFacebookCredentialRequest, DeleteGoogleCredentialRequest, DeletePhoneCredentialRequest, DeleteTelegramCredentialRequest, DeleteTwitterCredentialRequest, GetUserByUsernameReply, GetUserByUsernameRequest, GetUserReply, GetUserRequest, GetUsersByUsernameReply, GetUsersByUsernameRequest, GetUsersReply, GetUsersRequest, ListStatusLogsReply, ListStatusLogsRequest, ListUsersReply, ListUsersRequest, LockUserReply, LockUserRequest, LockUsersReply, LockUsersRequest, MeReply, ResendCreatePasswordOTPReply, ResendCreatePasswordOTPRequest, ResendResetPasswordOTPReply, ResendResetPasswordOTPRequest, ResendSignInOTPReply, ResendSignInOTPRequest, ResendSignUpOTPReply, ResendSignUpOTPRequest, ResetPasswordReply, ResetPasswordRequest, ResetPasswordV2Request, SaveOneClickInfoRequest, SignInCryptoWalletReply, SignInCryptoWalletRequest, SignInEmailRequest, SignInPhoneRequest, SignInReply, SignInRequest, SignInV2Request, SignUpCryptoWalletReply, SignUpCryptoWalletRequest, SignUpEmailReply, SignUpEmailRequest, SignUpOneClickReply, SignUpOneClickRequest, SignUpPhoneReply, SignUpPhoneRequest, SignUpReply, SignUpRequest, SignUpV2Request, SubmitResetPasswordRequest, UnbanUserReply, UnbanUserRequest, UnlockUserReply, UnlockUserRequest, UpdateEmailReply, UpdateEmailRequest, UpdateMetadataRequest, UpdatePasswordReply, UpdatePasswordRequest, UpdatePhoneNumberReply, UpdatePhoneNumberRequest, UpdatePhoneNumberV2Request, UpdateUserContactReply, UpdateUserContactRequest, UpdateUserReply, UpdateUserRequest, VerifyEmailReply, VerifyEmailRequest, VerifyPhoneNumberReply, VerifyPhoneNumberRequest, VerifyResetPasswordRequest } from "./myid_pb.mjs";
import { Empty, MethodKind } from "@bufbuild/protobuf";

/**
 * @generated from service greyhole.myid.MyID
 */
export const MyID = {
  typeName: "greyhole.myid.MyID",
  methods: {
    /**
     * deprecated
     *
     * @generated from rpc greyhole.myid.MyID.SignUp
     */
    signUp: {
      name: "SignUp",
      I: SignUpRequest,
      O: SignUpReply,
      kind: MethodKind.Unary,
    },
    /**
     * deprecated
     *
     * @generated from rpc greyhole.myid.MyID.SignIn
     */
    signIn: {
      name: "SignIn",
      I: SignInRequest,
      O: SignInReply,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc greyhole.myid.MyID.SignUpV2
     */
    signUpV2: {
      name: "SignUpV2",
      I: SignUpV2Request,
      O: SignUpReply,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc greyhole.myid.MyID.SignUpOneClick
     */
    signUpOneClick: {
      name: "SignUpOneClick",
      I: SignUpOneClickRequest,
      O: SignUpOneClickReply,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc greyhole.myid.MyID.SaveOneClickInfo
     */
    saveOneClickInfo: {
      name: "SaveOneClickInfo",
      I: SaveOneClickInfoRequest,
      O: Empty,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc greyhole.myid.MyID.SignUpPhone
     */
    signUpPhone: {
      name: "SignUpPhone",
      I: SignUpPhoneRequest,
      O: SignUpPhoneReply,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc greyhole.myid.MyID.SignUpEmail
     */
    signUpEmail: {
      name: "SignUpEmail",
      I: SignUpEmailRequest,
      O: SignUpEmailReply,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc greyhole.myid.MyID.SignUpCryptoWallet
     */
    signUpCryptoWallet: {
      name: "SignUpCryptoWallet",
      I: SignUpCryptoWalletRequest,
      O: SignUpCryptoWalletReply,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc greyhole.myid.MyID.SignInV2
     */
    signInV2: {
      name: "SignInV2",
      I: SignInV2Request,
      O: SignInReply,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc greyhole.myid.MyID.SignInPhone
     */
    signInPhone: {
      name: "SignInPhone",
      I: SignInPhoneRequest,
      O: SignInReply,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc greyhole.myid.MyID.SignInEmail
     */
    signInEmail: {
      name: "SignInEmail",
      I: SignInEmailRequest,
      O: SignInReply,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc greyhole.myid.MyID.SignInCryptoWallet
     */
    signInCryptoWallet: {
      name: "SignInCryptoWallet",
      I: SignInCryptoWalletRequest,
      O: SignInCryptoWalletReply,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc greyhole.myid.MyID.AddCredential
     */
    addCredential: {
      name: "AddCredential",
      I: AddCredentialRequest,
      O: Empty,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc greyhole.myid.MyID.ResendSignUpPhoneOTP
     */
    resendSignUpPhoneOTP: {
      name: "ResendSignUpPhoneOTP",
      I: ResendSignUpOTPRequest,
      O: ResendSignUpOTPReply,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc greyhole.myid.MyID.ConfirmSignUpPhone
     */
    confirmSignUpPhone: {
      name: "ConfirmSignUpPhone",
      I: ConfirmSignUpRequest,
      O: ConfirmSignUpReply,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc greyhole.myid.MyID.ResendSignUpEmailOTP
     */
    resendSignUpEmailOTP: {
      name: "ResendSignUpEmailOTP",
      I: ResendSignUpOTPRequest,
      O: ResendSignUpOTPReply,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc greyhole.myid.MyID.ConfirmSignUpEmail
     */
    confirmSignUpEmail: {
      name: "ConfirmSignUpEmail",
      I: ConfirmSignUpRequest,
      O: ConfirmSignUpReply,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc greyhole.myid.MyID.ResendSignInOTP
     */
    resendSignInOTP: {
      name: "ResendSignInOTP",
      I: ResendSignInOTPRequest,
      O: ResendSignInOTPReply,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc greyhole.myid.MyID.ConfirmSignIn
     */
    confirmSignIn: {
      name: "ConfirmSignIn",
      I: ConfirmSignInRequest,
      O: ConfirmSignInReply,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc greyhole.myid.MyID.ResendSignInPhoneOTP
     */
    resendSignInPhoneOTP: {
      name: "ResendSignInPhoneOTP",
      I: ResendSignInOTPRequest,
      O: ResendSignInOTPReply,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc greyhole.myid.MyID.ConfirmSignInPhone
     */
    confirmSignInPhone: {
      name: "ConfirmSignInPhone",
      I: ConfirmSignInRequest,
      O: ConfirmSignInReply,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc greyhole.myid.MyID.ResendSignInEmailOTP
     */
    resendSignInEmailOTP: {
      name: "ResendSignInEmailOTP",
      I: ResendSignInOTPRequest,
      O: ResendSignInOTPReply,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc greyhole.myid.MyID.ConfirmSignInEmail
     */
    confirmSignInEmail: {
      name: "ConfirmSignInEmail",
      I: ConfirmSignInRequest,
      O: ConfirmSignInReply,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc greyhole.myid.MyID.ConfirmCryptoWallet
     */
    confirmCryptoWallet: {
      name: "ConfirmCryptoWallet",
      I: ConfirmCryptoWalletRequest,
      O: ConfirmCryptoWalletReply,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc greyhole.myid.MyID.SignOut
     */
    signOut: {
      name: "SignOut",
      I: Empty,
      O: Empty,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc greyhole.myid.MyID.CreatePassword
     */
    createPassword: {
      name: "CreatePassword",
      I: CreatePasswordRequest,
      O: Empty,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc greyhole.myid.MyID.CreateAccessToken
     */
    createAccessToken: {
      name: "CreateAccessToken",
      I: CreateAccessTokenRequest,
      O: CreateAccessTokenReply,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc greyhole.myid.MyID.Me
     */
    me: {
      name: "Me",
      I: Empty,
      O: MeReply,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc greyhole.myid.MyID.ChangePassword
     */
    changePassword: {
      name: "ChangePassword",
      I: ChangePasswordRequest,
      O: Empty,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc greyhole.myid.MyID.UpdateMetadata
     */
    updateMetadata: {
      name: "UpdateMetadata",
      I: UpdateMetadataRequest,
      O: Empty,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc greyhole.myid.MyID.UpdateEmail
     */
    updateEmail: {
      name: "UpdateEmail",
      I: UpdateEmailRequest,
      O: UpdateEmailReply,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc greyhole.myid.MyID.VerifyEmail
     */
    verifyEmail: {
      name: "VerifyEmail",
      I: VerifyEmailRequest,
      O: VerifyEmailReply,
      kind: MethodKind.Unary,
    },
    /**
     * deprecated
     *
     * @generated from rpc greyhole.myid.MyID.UpdatePhoneNumber
     */
    updatePhoneNumber: {
      name: "UpdatePhoneNumber",
      I: UpdatePhoneNumberRequest,
      O: UpdatePhoneNumberReply,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc greyhole.myid.MyID.UpdatePhoneNumberV2
     */
    updatePhoneNumberV2: {
      name: "UpdatePhoneNumberV2",
      I: UpdatePhoneNumberV2Request,
      O: UpdatePhoneNumberReply,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc greyhole.myid.MyID.VerifyPhoneNumber
     */
    verifyPhoneNumber: {
      name: "VerifyPhoneNumber",
      I: VerifyPhoneNumberRequest,
      O: VerifyPhoneNumberReply,
      kind: MethodKind.Unary,
    },
    /**
     * deprecated
     *
     * @generated from rpc greyhole.myid.MyID.ResetPassword
     */
    resetPassword: {
      name: "ResetPassword",
      I: ResetPasswordRequest,
      O: ResetPasswordReply,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc greyhole.myid.MyID.ResetPasswordV2
     */
    resetPasswordV2: {
      name: "ResetPasswordV2",
      I: ResetPasswordV2Request,
      O: ResetPasswordReply,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc greyhole.myid.MyID.VerifyResetPassword
     */
    verifyResetPassword: {
      name: "VerifyResetPassword",
      I: VerifyResetPasswordRequest,
      O: Empty,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc greyhole.myid.MyID.SubmitResetPassword
     */
    submitResetPassword: {
      name: "SubmitResetPassword",
      I: SubmitResetPasswordRequest,
      O: Empty,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc greyhole.myid.MyID.ChangePhonePassword
     */
    changePhonePassword: {
      name: "ChangePhonePassword",
      I: ChangePasswordRequest,
      O: Empty,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc greyhole.myid.MyID.ResetPhonePassword
     */
    resetPhonePassword: {
      name: "ResetPhonePassword",
      I: ResetPasswordV2Request,
      O: ResetPasswordReply,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc greyhole.myid.MyID.VerifyResetPhonePassword
     */
    verifyResetPhonePassword: {
      name: "VerifyResetPhonePassword",
      I: VerifyResetPasswordRequest,
      O: Empty,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc greyhole.myid.MyID.SubmitResetPhonePassword
     */
    submitResetPhonePassword: {
      name: "SubmitResetPhonePassword",
      I: SubmitResetPasswordRequest,
      O: Empty,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc greyhole.myid.MyID.ChangeEmailPassword
     */
    changeEmailPassword: {
      name: "ChangeEmailPassword",
      I: ChangePasswordRequest,
      O: Empty,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc greyhole.myid.MyID.ResetEmailPassword
     */
    resetEmailPassword: {
      name: "ResetEmailPassword",
      I: ResetPasswordV2Request,
      O: ResetPasswordReply,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc greyhole.myid.MyID.VerifyResetEmailPassword
     */
    verifyResetEmailPassword: {
      name: "VerifyResetEmailPassword",
      I: VerifyResetPasswordRequest,
      O: Empty,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc greyhole.myid.MyID.SubmitResetEmailPassword
     */
    submitResetEmailPassword: {
      name: "SubmitResetEmailPassword",
      I: SubmitResetPasswordRequest,
      O: Empty,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc greyhole.myid.MyID.CheckCredential
     */
    checkCredential: {
      name: "CheckCredential",
      I: CheckCredentialRequest,
      O: Empty,
      kind: MethodKind.Unary,
    },
  }
};

/**
 * @generated from service greyhole.myid.TheCoffeeHouse
 */
export const TheCoffeeHouse = {
  typeName: "greyhole.myid.TheCoffeeHouse",
  methods: {
    /**
     * @generated from rpc greyhole.myid.TheCoffeeHouse.CreateUser
     */
    createUser: {
      name: "CreateUser",
      I: CreateUserRequest,
      O: CreateUserReply,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc greyhole.myid.TheCoffeeHouse.ListUsers
     */
    listUsers: {
      name: "ListUsers",
      I: ListUsersRequest,
      O: ListUsersReply,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc greyhole.myid.TheCoffeeHouse.UpdateUser
     */
    updateUser: {
      name: "UpdateUser",
      I: UpdateUserRequest,
      O: UpdateUserReply,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc greyhole.myid.TheCoffeeHouse.LockUser
     */
    lockUser: {
      name: "LockUser",
      I: LockUserRequest,
      O: LockUserReply,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc greyhole.myid.TheCoffeeHouse.LockUsers
     */
    lockUsers: {
      name: "LockUsers",
      I: LockUsersRequest,
      O: LockUsersReply,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc greyhole.myid.TheCoffeeHouse.UnlockUser
     */
    unlockUser: {
      name: "UnlockUser",
      I: UnlockUserRequest,
      O: UnlockUserReply,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc greyhole.myid.TheCoffeeHouse.BanUser
     */
    banUser: {
      name: "BanUser",
      I: BanUserRequest,
      O: BanUserReply,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc greyhole.myid.TheCoffeeHouse.BanUsers
     */
    banUsers: {
      name: "BanUsers",
      I: BanUsersRequest,
      O: BanUsersReply,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc greyhole.myid.TheCoffeeHouse.UnbanUser
     */
    unbanUser: {
      name: "UnbanUser",
      I: UnbanUserRequest,
      O: UnbanUserReply,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc greyhole.myid.TheCoffeeHouse.GetUser
     */
    getUser: {
      name: "GetUser",
      I: GetUserRequest,
      O: GetUserReply,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc greyhole.myid.TheCoffeeHouse.ResendCreatePasswordOTP
     */
    resendCreatePasswordOTP: {
      name: "ResendCreatePasswordOTP",
      I: ResendCreatePasswordOTPRequest,
      O: ResendCreatePasswordOTPReply,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc greyhole.myid.TheCoffeeHouse.GetUsers
     */
    getUsers: {
      name: "GetUsers",
      I: GetUsersRequest,
      O: GetUsersReply,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc greyhole.myid.TheCoffeeHouse.ResendResetPasswordOTP
     */
    resendResetPasswordOTP: {
      name: "ResendResetPasswordOTP",
      I: ResendResetPasswordOTPRequest,
      O: ResendResetPasswordOTPReply,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc greyhole.myid.TheCoffeeHouse.ListStatusLogs
     */
    listStatusLogs: {
      name: "ListStatusLogs",
      I: ListStatusLogsRequest,
      O: ListStatusLogsReply,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc greyhole.myid.TheCoffeeHouse.ChangePlayerPassword
     */
    changePlayerPassword: {
      name: "ChangePlayerPassword",
      I: ChangePlayerPasswordRequest,
      O: ChangePlayerPasswordReply,
      kind: MethodKind.Unary,
    },
  }
};

/**
 * @generated from service greyhole.myid.Waitress
 */
export const Waitress = {
  typeName: "greyhole.myid.Waitress",
  methods: {
    /**
     * @generated from rpc greyhole.myid.Waitress.GetUsers
     */
    getUsers: {
      name: "GetUsers",
      I: GetUsersRequest,
      O: GetUsersReply,
      kind: MethodKind.Unary,
    },
    /**
     * deprecated (because this does not support multi tenant)
     *
     * @generated from rpc greyhole.myid.Waitress.GetUsersByUsername
     */
    getUsersByUsername: {
      name: "GetUsersByUsername",
      I: GetUsersByUsernameRequest,
      O: GetUsersByUsernameReply,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc greyhole.myid.Waitress.GetUserByUsername
     */
    getUserByUsername: {
      name: "GetUserByUsername",
      I: GetUserByUsernameRequest,
      O: GetUserByUsernameReply,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc greyhole.myid.Waitress.CheckCredentials
     */
    checkCredentials: {
      name: "CheckCredentials",
      I: SignInV2Request,
      O: CheckCredentialsReply,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc greyhole.myid.Waitress.UpdateUserContact
     */
    updateUserContact: {
      name: "UpdateUserContact",
      I: UpdateUserContactRequest,
      O: UpdateUserContactReply,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc greyhole.myid.Waitress.UpdatePassword
     */
    updatePassword: {
      name: "UpdatePassword",
      I: UpdatePasswordRequest,
      O: UpdatePasswordReply,
      kind: MethodKind.Unary,
    },
    /**
     * API for testing sign up credential
     *
     * @generated from rpc greyhole.myid.Waitress.DeleteFacebookCredential
     */
    deleteFacebookCredential: {
      name: "DeleteFacebookCredential",
      I: DeleteFacebookCredentialRequest,
      O: Empty,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc greyhole.myid.Waitress.DeleteGoogleCredential
     */
    deleteGoogleCredential: {
      name: "DeleteGoogleCredential",
      I: DeleteGoogleCredentialRequest,
      O: Empty,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc greyhole.myid.Waitress.DeletePhoneCredential
     */
    deletePhoneCredential: {
      name: "DeletePhoneCredential",
      I: DeletePhoneCredentialRequest,
      O: Empty,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc greyhole.myid.Waitress.DeleteTwitterCredential
     */
    deleteTwitterCredential: {
      name: "DeleteTwitterCredential",
      I: DeleteTwitterCredentialRequest,
      O: Empty,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc greyhole.myid.Waitress.DeleteTelegramCredential
     */
    deleteTelegramCredential: {
      name: "DeleteTelegramCredential",
      I: DeleteTelegramCredentialRequest,
      O: Empty,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc greyhole.myid.Waitress.DeleteCryptoWalletCredential
     */
    deleteCryptoWalletCredential: {
      name: "DeleteCryptoWalletCredential",
      I: DeleteCryptoWalletCredentialRequest,
      O: Empty,
      kind: MethodKind.Unary,
    },
  }
};

/**
 * @generated from service greyhole.myid.Latte
 */
export const Latte = {
  typeName: "greyhole.myid.Latte",
  methods: {
    /**
     * @generated from rpc greyhole.myid.Latte.ResetToken
     */
    resetToken: {
      name: "ResetToken",
      I: Empty,
      O: Empty,
      kind: MethodKind.Unary,
    },
  }
};

